import { WebsiteConfigBM } from '@bm-js/atlascloud-shared'

export const updateFontCssVars = (websiteConfig: WebsiteConfigBM) => {
  const font = websiteConfig?.font || 'fontInterNunito'
  const root = document.querySelector(':root') as HTMLElement
  if (!root) return
  let textFont = '"Nunito Sans", sans-serif'
  let buttonFont = '"Inter", sans-serif'

  switch (font) {
    case 'fontSofiaPro':
      textFont = '"sofia-pro", sans-serif'
      buttonFont = '"sofia-pro", sans-serif'
      break

    default:
      textFont = '"Nunito Sans", sans-serif'
      buttonFont = '"Inter", sans-serif'
      break
  }
  root.style.setProperty('--customer-text-font', textFont)
  root.style.setProperty('--customer-button-font', buttonFont)
}
